import { useMutation } from '@apollo/client';
import ActivateProductMutation from './ActivateProductMutation';

interface IActivateProductConnectorApollo {
  children: ({
    activateProduct,
  }: {
    activateProduct: (accessCode: string) => Promise<unknown>;
  }) => JSX.Element;
}

const ActivateProductConnectorApollo: React.FC<IActivateProductConnectorApollo> = ({
  children,
}) => {
  const [activateProduct] = useMutation(ActivateProductMutation);

  const createActivateProduct = async (accessCode: string) => {
    const response = await activateProduct({
      variables: { accessCode },
    });

    return response;
  };

  return children({ activateProduct: createActivateProduct });
};

export default ActivateProductConnectorApollo;
